var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowDark = function SvgArrowDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 288 288",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 288,
    viewBox: "0 0 12.239 6.927",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "colorffebc3 svgShape",
    transform: "rotate(90 -7.553 929.45)",
    d: "M-937,921.086l.808.808,6.119-6.119-6.119-6.119-.808.808,5.311,5.311L-937,921.086Z",
    fill: "#1d4648",
    fillRule: "evenodd"
  }))));
};

export { SvgArrowDark as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyODggMjg4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8c3ZnIHdpZHRoPSIyODgiIGhlaWdodD0iMjg4IiB2aWV3Qm94PSIwIDAgMTIuMjM5IDYuOTI3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBjbGFzcz0iY29sb3JmZmViYzMgc3ZnU2hhcGUiIHRyYW5zZm9ybT0icm90YXRlKDkwIC03LjU1MyA5MjkuNDUpIiBkPSJNLTkzNyw5MjEuMDg2bC44MDguODA4LDYuMTE5LTYuMTE5LTYuMTE5LTYuMTE5LS44MDguODA4LDUuMzExLDUuMzExTC05MzcsOTIxLjA4NloiIGZpbGw9IiMxZDQ2NDgiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4KPC9zdmc+Cg==";